// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WifiOutlinedSvg from "@fishx/icons-svg/es/asn/WifiOutlined";
import FishxIcon from '../components/FishxIcon';

var WifiOutlined = function WifiOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WifiOutlinedSvg
  }));
};

WifiOutlined.displayName = 'WifiOutlined';
export default React.forwardRef(WifiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WifiOutlined.js
// module id = 4410
// module chunks = 0